/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener('DOMContentLoaded', () => {
  customElements.whenDefined('hover-disclosure').then(() => {
    const HoverDisclosure = customElements.get('hover-disclosure');
    const proto = HoverDisclosure.prototype;
    const originalHide = proto.hideDisclosure;
    const originalShow = proto.showDisclosure;

    proto.hideDisclosure = function () {
      clearTimeout(this._hideTimer);
      this._hideTimer = setTimeout(() => {
        originalHide.call(this);
      }, 200);
    };

    proto.showDisclosure = function (e) {
      // Cancel any pending hide when we re-enter
      clearTimeout(this._hideTimer);
      originalShow.call(this, e);
    };
  });
});

// Autoplay PDP gallery videos muted once their slide scrolls into view, pause when it leaves.
// Loads via loadContent(false) instead of clicking the poster: the click path focuses the
// video, which on mobile scrolls the slider straight to the video slide on page load.
// (browsers only allow autoplay without a real user click when the video is muted)
// The template video has preload="none" + autoplay, so the theme calls play() before any data
// is buffered; on mobile the clock then runs on a frozen frame until the first loop restarts it.
// We strip autoplay, buffer the video, and only call play() once a frame can be rendered.
window.addEventListener('load', () => {
  const slides = document.querySelectorAll('.product__slide[data-video]');
  if (!slides.length || !('IntersectionObserver' in window)) return;

  const playWhenReady = (video) => {
    video.muted = true;
    video.playsInline = true;
    video.controls = false;

    const play = () => video.play().catch((err) => console.warn('PDP video autoplay blocked:', err));
    if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
      play();
    } else {
      video.addEventListener('canplay', play, {once: true});
      if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
    }
  };

  customElements.whenDefined('deferred-media').then(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const deferredMedia = entry.target.querySelector('deferred-media');
        if (!deferredMedia) return;

        if (entry.isIntersecting) {
          if (!deferredMedia.getAttribute('loaded')) {
            const templateVideo = deferredMedia.querySelector('template')?.content.querySelector('video');
            templateVideo?.removeAttribute('autoplay');
            templateVideo?.removeAttribute('controls');
            templateVideo?.setAttribute('preload', 'auto');
            deferredMedia.loadContent(false);
          }

          const video = deferredMedia.querySelector('video');
          if (video) playWhenReady(video);
        } else {
          deferredMedia.querySelector('video')?.pause();
        }
      });
    }, {threshold: 0.5});

    slides.forEach((slide) => observer.observe(slide));
  });
});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
